<template>
    <div class="px-2 md:w-9/12 lg:w-7/12 m-auto mt-12 ">

        <div class="flex my-3 ">
            <a href="javascript:void(0)" @click="$router.back()" >
                <svg class="w-[30px] h-[30px] text-gray-800 mr-2 text-xl" aria-hidden="true" 
                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="black" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" 
                    stroke-width="1" d="M5 12h14M5 12l4-4m-4 4 4 4"/>
                </svg>
            </a>

            <span class="text-xl flex-1"> Edit Feed Source</span>

            <router-link  :to="{path:'/Feeds/'+feedProcessor._id}"
            class="mx-3 text-blue-600 p-2"> Feeds </router-link >
        </div>

    <div v-if="loading" class="text-center bg-white p-12 m-2">
        <svg  aria-hidden="true" class="w-8 h-8 m-auto text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="black" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"  fill="#e5e7eb"/>
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
        </svg>
    </div>
    <div v-else class="bg-white p-5 border rounded">

        <div class="mt-4">
            <label for="Title">Title</label>
            <input name="Title" type="text"  placeholder=""  v-model="feedProcessor.title"
            class="py-2 px-3 w-full  bg-white line-height-5 rounded-md border border-gray-300">
        </div>

        <div class="mt-4">
            <label for="Link">Link</label>
            <input name="Link" type="text"  placeholder=""  v-model="feedProcessor.link" @input="checkLink()"
            class="py-2 px-3 w-full  bg-white line-height-5 rounded-md border border-gray-300">
        </div>

        <div>
            <label class="inline-flex items-center cursor-pointer mt-4">
                <span class="text-sm font-medium text-gray-900 me-4 w-20">WebHook</span>
                <input type="checkbox" value="" v-model="feedProcessor.activeWebHook" class="sr-only peer">
                <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none 
                peer-focus:ring-0 peer-focus:ring-blue-300  
                rounded-full peer  peer-checked:after:translate-x-full 
                rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white 
                after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white 
                after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 
                after:transition-all peer-checked:bg-blue-600"></div>
            </label>
        </div>
        

        <div class="mt-4" v-if="feedProcessor.activeWebHook">
            <label for="WebHook">WebHook Link</label>
            <div class="flex flex-col">
                <input name="WebHook" type="text"  placeholder="" v-model="feedProcessor.webHook" @input="checkWebHookLink()"
                class="py-2 px-3 w-full bg-white line-height-5 rounded-md border border-gray-300">
                <span class="text-xs"> Automatically fires when a new item is discovered. </span>
            </div>
        

        </div>
        <div class="flex flex-col">
            <label class="inline-flex items-center cursor-pointer mt-10">
                <span class="text-sm font-medium text-gray-900 me-4 w-30"> Schedule</span>
                <input type="checkbox" value="" v-model="feedProcessor.active" class="sr-only peer">
                <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none
                peer-focus:ring-0 peer-focus:ring-blue-300 
                rounded-full peer peer-checked:after:translate-x-full 
                rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white 
                after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white 
                after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 
                after:transition-all peer-checked:bg-blue-600"></div>
            </label>
            <span class="text-xs"> {{ refreshRateMessage()}}</span>
        </div>
       
        <div class="flex">
            <button @click.prevent="$refs.deleteFormRef.open({deleteFeedProcessorId: feedProcessor._id})"  
            class="cursor-pointer text-red-600 mt-6 border-red-600
            line-height-5 py-2 px-4 font-weight-bold m-auto w-40 rounded-md border">Delete</button>

            <button @click.prevent="saveFeedProcessor()"  class="cursor-pointer text-white rounded-md mt-6
            line-height-5 bg-gray-700 py-2 px-4 font-weight-bold m-auto w-80">Save</button>
            
        </div>
    </div>
      <PopupMessage ref="deleteFormRef" :confirmedFun="deleteFeedProcessor" :title="'Please Confirm'" :text="'Sure you want to delete?'" />
    </div>
  </template>

<script>
import PopupMessage from '@/components/PopupMessage'

export default {
    name: 'FeedProcessor',
    components: {
        PopupMessage
    },
    async mounted(){
        const id = this.$route.params.id;
        if(id){
            this.getFeedProcessor(id);
        }
    },
    data () {
      return {
        loading:true,
        feedProcessor:{},
      }
    },
    methods: {
        refreshRateMessage(){
            const { premiumPlan, plan } = this.$store.state.user

            const planMessage= {
                FREE :'The schedule check for new feed items every 3 hours On the free plan',
                BASIC:'The schedule check for new feed items every 60 minutes on the Basic plan.',
                ADVANCED :'The schedule check for new feed items every 30 minutes On the Advanced plan',
                PREMIUM :'The schedule check for new feed items every 30 Minutes On the Premium plan'
            }
            
            return planMessage[premiumPlan&&plan?plan:'FREE'];
        }, 
        async getFeedProcessor(id){
            this.loading = true;
            const res = await this.$store.state.axiosInstance.get(this.$store.state.API_ENDPOINT + '/v1/feedProcessor/'+id,{
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
            });
            this.loading = false;
            if(res.data && res.data.data){
                this.feedProcessor = res.data.data;
            }else {
                this.$store.state.toastr.open({timeOut:5000, type:"error", 
                title:'Failed ', text: 'Get feed source failed'});
            } 
        },
        async deleteFeedProcessor(query){
            if(!query.deleteFeedProcessorId){return}
            this.loading = true;
            const res = await this.$store.state.axiosInstance.delete(this.$store.state.API_ENDPOINT+'/v1/feedProcessor/' + this.feedProcessor._id,{
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
            });
            this.loading = false;
            if(res.data&&res.data.success){
                this.$store.state.toastr.open({timeOut:5000, type:"success", 
                title:'Success ', text: 'Feed source deleted successfully'});
                this.$router.push({path:'/'})
            }else if(res.data&&res.data.message){
                this.$store.state.toastr.open({timeOut:5000, type:"error", 
                title:'Failed ', text: res.data.message || 'Delete feed source failed'});
            }
        },
        async saveFeedProcessor(){
            if(!this.feedProcessor.title){return this.$store.state.toastr.open({timeOut:3000, 
                type:"error", title:'Failed ', text: 'Please enter feed source title'});
            }
            if(!this.feedProcessor.link){return this.$store.state.toastr.open({timeOut:3000, 
                type:"error", title:'Failed ', text: 'Please enter feed source link'}); }

            if(this.checkLink() || this.checkWebHookLink()){ return; }
                console.log('==checkWebHookLink==')
            this.loading = true;
            const res = await this.$store.state.axiosInstance.put(this.$store.state.API_ENDPOINT + '/v1/feedProcessor/' + 
            this.feedProcessor._id, this.feedProcessor ,{
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
            });
            this.loading = false;

            if(res.data && res.data.success){
                this.$store.state.toastr.open({timeOut:3000, 
                    type:"success", title:'Success ', text: 'Feed source saved successfully'});
            }else {
                this.$store.state.toastr.open({timeOut:3000, 
                    type:"error", title:'Failed ', text: res.data.message || 'Failed to save feed source' });
            } 
      },

      checkWebHookLink(){
        try{
            if(!this.feedProcessor.activeWebHook){ return false;}

            if(!this.feedProcessor.webHook){ return this.$store.state.toastr.open({timeOut:3000, 
                type:"error", title:'Failed ', text: 'No webHook link found'});}

            const myUrl = new URL(this.feedProcessor.webHook);
            const arr = ['make.com','zapier.com','ifttt.com', 'integrately.com',
            'youflows.com', 'localhost'];
            let validURL = arr.some(x=>myUrl.hostname.includes(x));
            if(!validURL){
                return this.$store.state.toastr.open({timeOut:3000, 
                    type:"error", title:'Failed ', text: 'Webhook domain not supported'});
            }

        } catch (e){
              return this.$store.state.toastr.open({timeOut:3000, 
                type:"error", title:'Failed ', text: 'invaild Webhook link'});
        }
      },
      
      checkLink(){
        try{

            if(!this.feedProcessor.link){ return this.$store.state.toastr.open({timeOut:3000, 
                type:"error", title:'Failed ', text: 'No link found'});
            }

            const myUrl = new URL(this.feedProcessor.link);
            const arr = [
                'twitter.com','x.com','facebook.com',
                'reddit.com','instagram.com', 'youtube.com',
                'linkedin.com'
            ];
            let validURL = arr.some(x=>myUrl.hostname.includes(x));

            if(!validURL){
                return this.$store.state.toastr.open({timeOut:3000, 
                    type:"error", title:'Failed ', text: 'Domain not supported'});
            }else{
                return false;
            }

        } catch (e){
              return this.$store.state.toastr.open({timeOut:3000, 
                type:"error", title:'Failed ', text: 'Invaild link'});
        }
            
      }
    }
  }

  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>


// WEBPACK FOOTER //
// src/pages/FeedProcessor.vue